import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { UsuarioPermisoService } from "../../service/UsuarioPermisoService";
import { InputComponent } from "../../components/InputComponent";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { RolPorEmpresaGrupo } from "../../models/administracion/RolPorEmpresaGrupo";
import { useToken } from "../../components/useToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const RolEmpresaGrupoLista = ({ setDialogRol }) => {
    const generic = new GenericComponent();
    const omodel = new RolPorEmpresaGrupo();
    let loadLazyTimeout = null;
    const [roles, setRoles] = useState(null);
    const permisoService = new UsuarioPermisoService();
    const { getAllToken, saveToken } = useToken();
    const history = useHistory();
    const toast = useRef(null);
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: roles, omodel, generic });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        if (loadLazyTimeout) {
            clearTimeout(loadLazyTimeout);
        }
        loadLazyTimeout = setTimeout(() => {
            let _lazyParams = lazyParams;
            permisoService.getRolGrupoEmpresa({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
                setTotalRecords(res.data.total);
                setRoles(res.data.registros);
                setLoading(false);
            });
        });
    }

    const cambiarRol = (rol) => {
        confirmDialog({
            group: 'confirmarRol',
            message: '¿Está seguro de cambiar al rol ' + rol.nombre + '?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => cambio(rol)
        });
    }

    const cambio = (rol) => {
        permisoService.consultarRecursoempresaGrupo(rol.permiso, rol.id).then(res => {
            let token = getAllToken();
            token.menus = res.data.menus;
            token.tipo = res.data.tipo;
            token.rol = rol;
            token.rol['rol_tipo'] = 'rol-permiso';
            token.rol['verAlerta'] = res.data.rol?.verAlerta;
            token.rol['tipo_rol'] = rol.tipo_rol;
            saveToken(token);
            history.push("/");
            setDialogRol(false);
        }).catch(error => {
            toast.current.show({ severity: 'error', summary: 'Error, comuníquese con el administrador.', detail: error.response.data.message, life: 3000 });
        })
    }

    const acciones = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-sign-in" title='Cambio de rol' className="p-button-rounded p-button-success mr-2" onClick={() => cambiarRol(rowData)} />
            </div>
        );
    }

    return (
        <>
            <Toast ref={toast} />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {table({ action5: acciones })}
            </Card>
        </>
    )
}
